import { useEffect, useState } from "react";
import { get } from "@/lib/api";
import { AlertTriangle, ChevronRight, CheckCircle2 } from "lucide-react";

const LEVEL = {
  high: "border-l-[#DC2626] bg-[#FEF2F2]",
  medium: "border-l-[#B45309] bg-[#FFFBEB]",
  low: "border-l-stone-300 bg-white",
};
const DOT = { high: "text-[#DC2626]", medium: "text-[#B45309]", low: "text-stone-400" };

export function NeedsAttention({ onNavigate, refreshKey }) {
  const [cards, setCards] = useState(null);
  useEffect(() => { get("/desk/attention").then((d) => setCards(d.cards)); }, [refreshKey]);
  if (!cards) return null;
  return (
    <section className="mb-8" data-testid="needs-attention">
      <h2 className="mb-3 flex items-center gap-2 font-display text-lg font-semibold text-mill-ink">
        <AlertTriangle className="h-5 w-5 text-[#B45309]" /> Needs attention
      </h2>
      {cards.length === 0 ? (
        <div className="flex items-center gap-2 rounded-2xl border border-[#A7F3D0] bg-[#F0FDF4] p-4 text-sm text-[#065F46]" data-testid="attention-clear">
          <CheckCircle2 className="h-4 w-4" /> Nothing needs your decision right now.
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-2.5 md:grid-cols-2">
          {cards.map((c, i) => (
            <button key={`${c.id}-${i}`} onClick={() => onNavigate?.(c.tab)} data-testid={`attention-card-${c.kind}`}
              className={`flex items-start justify-between gap-3 rounded-xl border border-stone-200 border-l-4 p-4 text-left transition-colors hover:bg-white ${LEVEL[c.level] || LEVEL.low}`}>
              <span>
                <span className="flex items-center gap-1.5 text-sm font-semibold text-mill-ink">
                  <span className={`h-1.5 w-1.5 rounded-full ${DOT[c.level]} bg-current`} /> {c.title}
                </span>
                <span className="mt-0.5 block text-xs leading-relaxed text-mill-muted">{c.detail}</span>
              </span>
              <ChevronRight className="mt-0.5 h-4 w-4 shrink-0 text-mill-muted" />
            </button>
          ))}
        </div>
      )}
    </section>
  );
}
